<template>
  <v-layout class="file-input-box" align-center>
    <span v-if="file" class="mf-body-2 secondary-text"> {{ file.name }} </span>
    <mf-button v-if="file" color="cinza-0" type="icon" icon="close" size="sm" @click="deleteFile" />
    <mf-button v-else label="Importar" @click="activateInput" />
    <input ref="file-input" class="hidden-input" type="file" @input="readFile($event)" />
  </v-layout>
</template>

<script>
export default {
  props: {
    fileContents: [Object, String],
  },
  data: () => ({
    file: null,
    fileName: '',
    fileType: '',
  }),
  computed: {
    fileContent: {
      get() {
        return this.fileContents
      },
      set(value) {
        this.$emit('update:fileContents', value)
        this.$emit('content-updated', { value, fileName: this.fileName, fileType: this.fileType })
      },
    },
  },
  methods: {
    readFile(event) {
      if (event.target.files.length === 0) return

      // if (event.target.files[0].type !== 'text/csv') {
      //   this.$snackbar({ message: 'Permitido apenas arquivos em .csv', snackbarColor: 'error' })
      //   return
      // }

      this.file = event.target.files[0]

      this.fileName = this.file.name
      this.fileType = this.file.type

      let reader = new FileReader()
      reader.onload = () => {
        this.fileContent = reader.result
      }
      reader.readAsText(this.file)
    },
    activateInput() {
      this.$refs['file-input'].value = null
      this.$refs['file-input'].click()
    },
    deleteFile() {
      this.fileContent = null
      this.file = null
    },
  },
}
</script>

<style lang="scss">
.file-input-box {
  .hidden-input {
    display: none;
  }
}
</style>
